import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense, useState } from 'react';
import { RouterProvider } from 'react-router';
import { Toaster } from '../components/ui/Toaster';
import { SessionProvider } from '../features/auth/SessionProvider';
import { createQueryClient } from '../lib/api/query-client';
import { router } from './router';
import { ThemeProvider } from './ThemeProvider';

export function App() {
  const [queryClient] = useState(createQueryClient);
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Toaster>
          <SessionProvider>
            <Suspense fallback={null}>
              <RouterProvider router={router} />
            </Suspense>
          </SessionProvider>
        </Toaster>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
